export default {
  gift_card_removed: 'Tarjeta de regalo eliminada',
  invalid_gift_card: 'La tarjeta de regalo no es válida',
  gift_card_applied: 'Tarjeta de regalo aplicada',
};
